if (!customElements.get('collections-jump-nav')) {
  class CollectionsJumpNav extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const pill = event.target.closest('[data-jump-pill]');

      if (!pill) return;

      this.querySelectorAll('[data-jump-pill]').forEach((item) => {
        const isActive = item === pill;

        item.classList.toggle('is-active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('collections-jump-nav', CollectionsJumpNav);
}
